webpackJsonp([212420072151734],{

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/app-icon.5899ca1f.png";

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screen-plan-today.a1ff5c14.jpg";

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screen-plans-list-clean.f4a37201.jpg";

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screen-progress-week.dcfdce54.jpg";

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screen-workout-logging.30561e07.jpg";

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    .hero {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    .screens {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  '], ['\n    .hero {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    .screens {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(8);
	
	var _Breakpoints = __webpack_require__(10);
	
	var _appIcon = __webpack_require__(382);
	
	var _appIcon2 = _interopRequireDefault(_appIcon);
	
	var _screenPlansListClean = __webpack_require__(384);
	
	var _screenPlansListClean2 = _interopRequireDefault(_screenPlansListClean);
	
	var _screenPlanToday = __webpack_require__(383);
	
	var _screenPlanToday2 = _interopRequireDefault(_screenPlanToday);
	
	var _screenWorkoutLogging = __webpack_require__(386);
	
	var _screenWorkoutLogging2 = _interopRequireDefault(_screenWorkoutLogging);
	
	var _screenProgressWeek = __webpack_require__(385);
	
	var _screenProgressWeek2 = _interopRequireDefault(_screenProgressWeek);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// The App Store URL for StrongList. While it is empty the hero shows a disabled
	// "Coming soon" badge; once it is set the badge becomes a normal link to the listing.
	var APP_STORE_URL = '';
	
	var brand = {
	  ink: '#172B2E',
	  jade: '#15A67C',
	  cream: '#F1EDE5'
	};
	
	var screenshots = [{ src: _screenPlansListClean2.default, alt: 'StrongList plan list with Push, Pull and Legs plans' }, { src: _screenPlanToday2.default, alt: 'A Pull plan ready to start, with its exercises and radar' }, { src: _screenWorkoutLogging2.default, alt: 'Logging a treadmill run during a Push workout' }, { src: _screenProgressWeek2.default, alt: 'Weekly progress with the six-region radar and set totals' }];
	
	var PageStyled = _styledComponents2.default.article.withConfig({
	  displayName: 'stronglist__PageStyled',
	  componentId: 'sc-1rbwk8l-0'
	})(['color:', ';a,a:link,a:visited{color:', ';text-decoration:none;}a:hover{text-decoration:underline;}.hero{display:flex;align-items:center;gap:1.25rem;margin-bottom:1.5rem;padding:1.25rem;border-radius:14px;background:', ';color:', ';}.appIcon{flex:0 0 auto;display:block;width:112px;height:112px;border-radius:22.37%;overflow:hidden;box-shadow:0 1px 4px rgba(23,43,46,0.18);}.appIcon img{display:block;width:100%;height:100%;margin:0;}.eyebrow{margin:0 0 0.35rem;font-size:0.78rem;font-weight:bold;letter-spacing:0.08em;text-transform:uppercase;color:', ';}h3{margin:0;font-size:2.2rem;line-height:1.05;font-family:Georgia,\'Times New Roman\',serif;}.hero p{max-width:640px;margin:0.5rem 0 0;font-size:1.05rem;line-height:1.45;}.actions{display:flex;flex-wrap:wrap;align-items:center;gap:0.5rem 1rem;margin-top:0.9rem;}.appBadgeGroup{display:inline-flex;align-items:center;gap:10px;}.appBadge,.actions a.appBadge,.actions a.appBadge:link,.actions a.appBadge:visited{display:inline-flex;align-items:center;gap:9px;min-height:44px;box-sizing:border-box;padding:9px 18px;border:1px solid ', ';border-radius:10px;background:', ';color:#fff;text-decoration:none;}.actions a.appBadge:hover{background:#000;text-decoration:none;}.appBadge svg{flex:0 0 auto;fill:currentColor;}.appBadgeText{line-height:1;text-align:left;}.appBadgeLabel{margin-bottom:2px;font-size:9px;font-weight:500;opacity:0.7;}.appBadgeTitle{font-size:15px;font-weight:700;letter-spacing:-0.01em;}.appBadge.isSoon{border-color:rgba(23,43,46,0.2);background:rgba(23,43,46,0.07);color:', ';cursor:default;}.appBadgeStatus{font-size:11px;font-weight:600;color:rgba(23,43,46,0.6);}h4{margin:1.75rem 0 0.6rem;font-size:1.25rem;}ul{max-width:68ch;padding-left:1.2rem;line-height:1.55;}li + li{margin-top:0.35rem;}.screens{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:1rem;margin:0;padding:1rem;border-radius:14px;background:', ';}.screens figure{margin:0;}.screens img{display:block;width:100%;height:auto;border:1px solid rgba(23,43,46,0.12);border-radius:18px;background:#fff;}', ';'], _constants.colors.darkTextColor, _constants.colors.linkColor, brand.cream, brand.ink, brand.jade, brand.ink, brand.ink, brand.ink, brand.cream, _Breakpoints.media.tablet(_templateObject));
	
	// Apple logo paths from the SongForm site's AppStoreBadge component.
	var appleLogoPaths = [['M14.98 11.7c-.02-2.3 1.87-3.4 1.96-3.47-1.07-1.57-2.73-1.78-3.32-1.8-1.41-.14-2.', '76.83-3.47.83-.72 0-1.83-.81-3.01-.79C5.5 6.5 3.96 7.53 3.1 9.1c-1.76 3.06-.45 7', '.58 1.26 10.06.84 1.22 1.84 2.58 3.15 2.53 1.27-.05 1.74-.82 3.28-.82 1.52 0 1.9', '5.82 3.28.79 1.36-.02 2.22-1.22 3.05-2.44.97-1.4 1.36-2.77 1.38-2.84-.03-.01-2.6', '4-1.01-2.67-4.01z'].join(''), ['M12.7 3.8c.7-.85 1.17-2.02 1.04-3.2-1 .04-2.23.67-2.95 1.5-.64.74-1.2 1.93-1.05 ', '3.07 1.12.09 2.26-.57 2.96-1.37z'].join('')];
	
	var AppleLogo = function AppleLogo() {
	  return _react2.default.createElement(
	    'svg',
	    { width: '18', height: '22', viewBox: '0 0 18 22', 'aria-hidden': 'true' },
	    appleLogoPaths.map(function (d) {
	      return _react2.default.createElement('path', { key: d, d: d });
	    })
	  );
	};
	
	var AppBadgeContent = function AppBadgeContent() {
	  return _react2.default.createElement(
	    'span',
	    { className: 'appBadgeText' },
	    _react2.default.createElement(
	      'span',
	      { className: 'appBadgeLabel', style: { display: 'block' } },
	      'Download on the'
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'appBadgeTitle', style: { display: 'block' } },
	      'App Store'
	    )
	  );
	};
	
	var AppStoreLink = function AppStoreLink() {
	  return APP_STORE_URL ? _react2.default.createElement(
	    'a',
	    {
	      className: 'appBadge',
	      href: APP_STORE_URL,
	      target: '_blank',
	      rel: 'noopener noreferrer',
	      'aria-label': 'Download StrongList on the App Store'
	    },
	    _react2.default.createElement(AppleLogo, null),
	    _react2.default.createElement(AppBadgeContent, null)
	  ) : _react2.default.createElement(
	    'span',
	    { className: 'appBadgeGroup' },
	    _react2.default.createElement(
	      'span',
	      { className: 'appBadge isSoon', role: 'img', 'aria-label': 'App Store, coming soon' },
	      _react2.default.createElement(AppleLogo, null),
	      _react2.default.createElement(AppBadgeContent, null)
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'appBadgeStatus' },
	      'Coming soon'
	    )
	  );
	};
	
	var StrongListPage = function StrongListPage() {
	  return _react2.default.createElement(
	    PageStyled,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'StrongList - Roberto V\xE1zquez Gonz\xE1lez Site',
	      meta: [{
	        name: 'description',
	        content: 'StrongList, a simple workout log for iPhone and iPad. Plans, sets and progress.'
	      }]
	    }),
	    _react2.default.createElement(
	      'header',
	      { className: 'hero' },
	      _react2.default.createElement(
	        'span',
	        { className: 'appIcon' },
	        _react2.default.createElement('img', { src: _appIcon2.default, alt: 'StrongList app icon' })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          { className: 'eyebrow' },
	          'iOS app for iPhone and iPad'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'StrongList'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A simple workout log. Build your plans, log every set while you train and see how your week is going, in a calm app that looks like a gridded notebook.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'actions' },
	          _react2.default.createElement(AppStoreLink, null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'screens', 'aria-label': 'Screenshots' },
	      screenshots.map(function (shot) {
	        return _react2.default.createElement(
	          'figure',
	          { key: shot.src },
	          _react2.default.createElement('img', { src: shot.src, alt: shot.alt })
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'What it does'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Plans for strength, cardio and mobility, using a built-in catalog of 89 exercises or your own custom ones.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Start a workout, log sets, reps and weight (or minutes and distance for cardio), and follow it from the Lock Screen and the Dynamic Island with a Live Activity.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Progress by session, week or month: a six-region radar of sets per body area, total volume, cardio minutes and mobility sessions.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Remembers the machine number of each exercise in each gym you train at.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Import a routine from your trainer by pasting a prompt into the AI app you already use. StrongList itself sends nothing anywhere.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Local first: no account and no server. Optional sync through your own iCloud Drive, as readable JSON files.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Spanish and English, kilograms or pounds. Requires iOS 17 or later.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Help and privacy'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/projects/stronglist/support/' },
	            'Support and FAQ'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/projects/stronglist/privacy/' },
	            'Privacy policy'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = StrongListPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-stronglist-index-js-0fd203d9833a2ce701b2.js